// extracted by mini-css-extract-plugin
module.exports = {"canvas":"Output_canvas__8-y_l"};